export default __webpack_public_path__ + "static/media/front.f80608e6.svg";